import { lazy } from "react";

export const SitemapContent = lazy(() => import("./SitemapContent"));
